import { createContext, useContext, useReducer } from "react"
import { initialState, productImageReducer } from "../reducer/productImageReducer"

const ProductImageStateContext = createContext();
const ProductImageDispatchContext = createContext();

export const ProductImageProvider = ({ children }) => {
  const [state, dispatch] = useReducer(productImageReducer, initialState);

  return (
    <ProductImageStateContext.Provider value={state}>
      <ProductImageDispatchContext.Provider value={dispatch}>
        {children}
      </ProductImageDispatchContext.Provider>
    </ProductImageStateContext.Provider>
  )
}

export const useProductImageState = () => {
  const context = useContext(ProductImageStateContext);

  if (!context) throw Error('useProductImageState는 ProductImageProvider 내에서 사용해야 합니다.');
  return context;
}

export const useProductImageDispatch = () => {
  const context = useContext(ProductImageDispatchContext);

  if (!context) throw Error('useProductImageDispatch는 ProductImageProvider 내에서 사용해야 합니다.');
  return context;
}